// extracted by mini-css-extract-plugin
module.exports = {"emoryGoizuetaLogo":"style-module__emoryGoizuetaLogo___10xVt","nyuSternLogo":"style-module__nyuSternLogo___Twefm","magooshLogo":"style-module__magooshLogo___1Fk9A"};